export default __webpack_public_path__ + "static/media/Handle_DHP465.14e4b350.obj";